import { Sticker } from "../../models/sticker"
import styles from "./StickerPopover.module.scss"
import cn from "classnames"
import { ReactComponent as StickerIcon } from "../../assets/images/icons/sticker.svg"
import { useTranslation } from "react-i18next"
import { testId } from "../../utility/tests/testId/stickers"
import { dialogsTestIds } from "../../utility/tests/testId/dialogs"

type Props = {
    stickers: Sticker[]
    onStickerClick: (sticker: Sticker) => void
}

const tNamespace = "knowledgeBase:sticker."

export const StickersList: React.FC<Props> = props => {
    const { stickers, onStickerClick } = props
    const { t } = useTranslation()

    if (stickers.length) {
        return (
            <div className={cn(styles.stickerContainer)} data-testid={testId.stickerPopoverContainer}>
                {stickers.map(sticker => {
                    return (
                        <div key={sticker.Id} className={styles.stickerItem}>
                            <img
                                src={sticker.StickerUrl}
                                alt={sticker.Name}
                                onClick={() => onStickerClick(sticker)}
                                data-testid={`${dialogsTestIds.stickerPopoverItem}-${sticker.Id}`}
                            />
                        </div>
                    )
                })}
            </div>
        )
    }
    return (
        <div
            className={cn(styles.stickerMessageContainer, styles.stickerEmpty)}
            data-testid={testId.stickerPopoverEmptyMessage}
        >
            <StickerIcon width={48} height={48} />
            <div>{t(`${tNamespace}empty`)}</div>
        </div>
    )
}
